import * as React from 'react';
import type { SVGProps } from 'react';
const SvgComment = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={15}
    fill="none"
    viewBox="0 0 16 15"
    {...props}
  >
    <path
      fill="currentColor"
      d="M3.75 10h8.5c.213 0 .39-.071.534-.214A.72.72 0 0 0 13 9.255a.734.734 0 0 0-.216-.536.72.72 0 0 0-.534-.219h-8.5a.728.728 0 0 0-.534.215.72.72 0 0 0-.216.53c0 .212.072.39.216.536a.72.72 0 0 0 .534.22m0-2.75h8.5c.213 0 .39-.071.534-.214A.72.72 0 0 0 13 6.505a.734.734 0 0 0-.216-.536.72.72 0 0 0-.534-.219h-8.5a.728.728 0 0 0-.534.215.72.72 0 0 0-.216.53c0 .212.072.39.216.536a.72.72 0 0 0 .534.22m0-2.75h8.5c.213 0 .39-.071.534-.214A.72.72 0 0 0 13 3.755a.734.734 0 0 0-.216-.536A.72.72 0 0 0 12.25 3h-8.5a.728.728 0 0 0-.534.215.72.72 0 0 0-.216.53c0 .212.072.39.216.536a.72.72 0 0 0 .534.22M1.5 13c-.413 0-.766-.147-1.06-.44A1.444 1.444 0 0 1 0 11.5v-10C0 1.088.147.735.44.44.735.148 1.088 0 1.5 0h13c.412 0 .766.147 1.06.44.293.295.44.648.44 1.06v12.688c0 .336-.153.569-.458.7-.306.13-.578.077-.815-.161L13 13zm12.125-1.5.875.875V1.5h-13v10z"
    />
  </svg>
);
export default SvgComment;
